/**
 * Helpers for showing and hiding elements
 * @module lib/show_hide
 */

/**
 * Shows given element, potentially focusing, enabling or sending an event
 * @param {HTMLElement} el
 * @param {Object} options
 * @param {boolean} options.focus - Focuses the element if true
 * @param {boolean} options.enable - Enables the element if true
 * @param {boolean} options.enableControls - Enables form controls inside the element if true
 * @param {boolean} options.notify - Notifies that the element will be shown
 */
export function show(
  el,
  {
    focus = false,
    enable = false,
    enableControls = enable,
    notify = false
  } = {}
) {
  if (!el) return;
  if (notify) {
    dispatchWillShow(el);
  }
  el.classList.remove('d-none');
  focus && el.focus();
  enable && (el.disabled = false);
  if (enableControls) {
    Array.from(
      el.querySelectorAll(
        'input:not(.js-no-enable),select:not(.js-no-enable),textarea:not(.js-no-enable),[type="submit"]:not(.js-no-enable)'
      )
    ).forEach(e => {
      e.disabled = false;
    });
  }
}

function dispatchWillShow(el) {
  const event = new CustomEvent('willShow', { bubbles: true });
  el.dispatchEvent(event);
}

/**
 * Hides given element, possibly disabling it or the form controls it contains
 * @param {HTMLElement} el
 * @param {Object} options
 * @param {boolean} [options.disable=false] - Disables the element if true
 * @param {boolean} [options.disableControls = options.disable] - Disables the form controls inside the elements if true
 */
export function hide(el, { disable = false, disableControls = disable } = {}) {
  el && el.classList.add('d-none');
  disable && (el.disabled = true);
  if (disableControls) {
    Array.from(
      el.querySelectorAll('input,select,textarea,[type="submit"]')
    ).forEach(e => {
      e.disabled = true;
    });
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/show_hide.js